import { BACKEND_URL } from "../api/config";

export async function checkAuth() {
  try {
    const response = await fetch(`${BACKEND_URL}/check`, {
      credentials: "include",
    });

    if (response.status === 200) {
      return true;
    } else  {
      return false;
    }
  } catch (error) {
    console.error("Ошибка при запросе:", error);
    return false;
  }
}
